import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import { getSurmountAccountDocumentDetails } from "features/Dashboard/service";
import { toast } from "Layout/slice/index";
import { parseErrorMessage } from "utils/index";

export const DownloadDocument = ({ data }) => {
  const { id } = data;

  const dispatch = useDispatch();

  const handleView = async () => {
    try {
      const response = await getSurmountAccountDocumentDetails(id);
      if (response.data && response.data.url) {
        window.open(response.data.url, "_blank");
      } else {
        dispatch(
          toast({
            type: "warning",
            body: "Document URL not found",
          })
        );
      }
    } catch (error) {
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    }
  };
  return (
    <div className="view-document" onClick={handleView}>
      View details
    </div>
  );
};

DownloadDocument.propTypes = {
  data: PropTypes.any,
};
